import { Controller } from "stimulus"
import csrfPrefilter from "../components/csrf_prefilter";
import $ from 'jquery';
import createChannel from "cables/cable"

export default class extends Controller {
  static targets = [
    "messages"
  ]

  initOfferChatMessageChannel() {
    this.offerChatMessageChannel = createChannel(
      {
        channel: 'OfferChatMessageChannel',
        offer_chat_room_id: this.element.dataset.offerChatRoomId
      }, {
        received: data => {
          const sender = data.sender

          this.appendMessage(
            data.id, data.content, data.read_at, data.created_at,
            data.sender.uid, data.sender.name, data.sender.image_url
          );

          window.scrollTo(0, document.body.scrollHeight);

          if(sender.uid !== this.element.dataset.userUid) {
            csrfPrefilter();
            $.ajax({
              type: "post",
              url: `/offer_chat_rooms/${this.element.dataset.offerChatRoomId}/offer_chat_messages/${data.id}/read`,
            })
          }
        }
      }
    )
  }

  appendMessage(id, content, readAt, createdAt, userUid, userName, userImageUrl) {
    let html = "";

    const [_, createdAtDate, createdAtTime] = createdAt.match(/(\d{4}-\d{2}-\d{2})T(\d{2}:\d{2})/)
    const createdAtDateSlash = createdAtDate.replace(/-/g, "/");

    if(this.latestMessageDate !== createdAtDateSlash) {
      this.latestMessageDate = createdAtDateSlash;

      html += this.generateDateHtmlString(createdAtDateSlash);
    }

    html += this.generateMessageHtmlString(id, content, readAt, createdAtTime, userUid, userName, userImageUrl);

    this.messagesTarget.insertAdjacentHTML("beforeend", html);
  }

  generateDateHtmlString(date) {
    return `
      <div class="text-line-right">
        <p class="is-size-7">${date}</p>
      </div>
    `
  }

  generateMessageHtmlString(id, content, readAt, createdAtTime, userUid, userName, userImageUrl) {
    return `
      <div class="offer_chat_room-message py-3 px-2 ${readAt ? "read" : ""} ${userUid === this.userUid ? "my-message" : ""}" data-message-id="${id}">
        <article class="media is-flex is-align-items-center">
          <figure class="media-left">
            <p class="image is-32x32">
              <img class="has-background-white" src="${userImageUrl}">
            </p>
          </figure>
          <div class="media-content read-mark-parent">
            <div class="is-flex is-align-items-center">
              <div class="is-flex is-align-items-center">
                <h3 class="title is-5 mb-1 mr-2">${userName}</h3>
                <p class="is-size-8 is-align-self-center">${createdAtTime}</p>
              </div>
            </div>
          </div>
        </article>
        <div class="pre-wrap-text word-break-all content mt-3 mb-0">${this.linkifText(
          content
        )}</div>
        <div class="read-mark icon-text is-pulled-right is-size-8" style="${readAt ? "" : "display: none;"}">
          <span class="icon mr-0">
            <i class="fas fa-check"></i>
          </span>
          <span>既読</span>
        </div>
      </div>
    `;
  }

  linkifText(text) {
    return text.replace(
      /(https?:\/\/\S+)/g,
      "<a href='$1' target='_blank' rel='noopener noreferrer'>$1</a>"
    );
  }

  connect() {
    window.scrollTo(0, document.body.scrollHeight);
    this.initOfferChatMessageChannel();
  }

  disconnect() {
    this.offerChatMessageChannel.unsubscribe();
  }
}
